import React from "react";
import { Button, Tooltip } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { Link } from "@refinedev/core";
import { useNavigate } from "react-router";

interface ChartIconButtonProps {
    concentratorID: string;
    meterID: number;
    style?: React.CSSProperties;
    onClick?: () => void;
}

export const ChartIconButton: React.FC<ChartIconButtonProps> = ({
    concentratorID,
    meterID,
    style = { padding: '2px 4px', height: 'auto', minWidth: 'auto' },
    onClick
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(`/concentrators/${concentratorID}/meters/${meterID}/chart`);
        }
    };

    const button = (
        <Button
            type="text"
            size="small"
            icon={<BarChartOutlined />}
            style={style}
            onClick={onClick ? handleClick : undefined}
        />
    );

    return (
        <Tooltip title="View Chart">
            {onClick ? (
                button
            ) : (
                <Link to={`/concentrators/${concentratorID}/meters/${meterID}/chart`}>
                    {button}
                </Link>
            )}
        </Tooltip>
    );
};